import React, { Component } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Container, Wrapper } from './styles';
import SidebarMenu from './SideBar/SidebarMenu';
import MessageContainer from './EditingArea/MessageContainer';
// pages context API
import ShortMsgTextProvider from '../../context/shortMessageContext';
import { ShortMsgTextContext } from '../../context/shortMessageContext';
import { AppStoreContext } from '../../context/appStoreContext';
import ComplexDocumentHistoryProvider from '../../context/complexDocumentContext';
import BusinessLogicProvider from '../../context/businessLogicContext';
import ComplexArtboardProvider from '../../context/complexArtboardContext';

import { ShortMessageTabs } from '../../containers/SidebarMenu/tabIndexConstants';
/* Short message module 
  Child Components: 
    * SideBarMenu
    * MessageContainer
*/
class ShortMessageDesign extends Component {
  constructor() {
    super();
    this.state = {
      tabIndex: -1,
      previousTabIndex: -1,
      enableTabExpansion: true,
      variablesLayoutEnabled: false,
      templates: {},
      templateId: undefined,
      tempName: 'untitled',
      showVersions: false,
    };
    this.tabClickHandler = this.tabClickHandler.bind(this);
    this.layoutToolbarHandler = this.layoutToolbarHandler.bind(this);
    this.updateDocumentVariables = this.updateDocumentVariables.bind(this);
  }

  async componentDidMount() {
    if (this.props.match?.params?.templateId && !this.context.loginVisible) {
      await this.context.updateGlobalVariables(null, 'fetchAllVariables');
      this.setState({
        templateId: this.props.match.params.templateId,
      });
      const { history } = this.props;
      const location = history.location;
      const { state } = location;
      if(state) {
        this.tabClickHandler(parseInt(state?.tabIndex));
        history.replace({ tabIndex: undefined });
      } else {
        this.tabClickHandler(-1);
      }
    }
    this.updateVariables = async () => {
      await this.context.updateGlobalVariables(null, 'fetchAllVariables');
    };
    window.addEventListener("variablesUpdated", this.updateVariables);
  }
  componentWillUnmount() {
    window.removeEventListener("variablesUpdated", this.updateVariables);
  }

  componentDidUpdate() {
    const { templateId } = this.state;
    if (
      this.props.match?.params?.templateId &&
      !this.context.loginVisible &&
      this.context.variablesFetched
    ) {
      if (templateId !== this.props.match?.params?.templateId) {
        this.setState({ templateId: this.props.match.params.templateId });
      }
    }
  }

  tabClickHandler(index) {
    this.setState({
      tabIndex: index,
      variablesLayoutEnabled: false,
    });
    if (index >= 0) {
      this.setState({ previousTabIndex: index, enableTabExpansion: true });
    } else {
      this.setState({ enableTabExpansion: false });
    }
    if (index === 9) {
      this.setState({ variablesLayoutEnabled: true });
    }
  }

  layoutToolbarHandler(status) {
    if (!this.state.variablesLayoutEnabled) {
      if (status) {
        this.setState({
          tabIndex: -1,
        });
      } else {
        if (this.state.enableTabExpansion) {
          this.setState({
            tabIndex: this.state.previousTabIndex,
          });
        }
      }
    }
  }

  toggleSideBar = (collapse = false) => {
    this.setState({
      previousTabIndex: collapse ? this.state.tabIndex : this.state.previousTabIndex,
      tabIndex: collapse ? -1 : this.state.previousTabIndex,
    });
  };

  updateDocumentVariables(documentVariables) {
    this.context.setDocumentVariables(documentVariables);
  }

  setTemplateName = e => {
    this.setState({ tempName: e });
  };

  onTemplateSave = templates => {
    this.setState({ templates });
  };

  render() {
    const { tabIndex, templates, tempName, showVersions, templateId } = this.state;

    return (
      <Container>
        <Wrapper>
          <DndProvider backend={HTML5Backend} key={1} context={window}>
            <ShortMsgTextProvider>
              <ShortMsgTextContext.Consumer>
                {shortMsgTextContext => (
                  <>
                    <ComplexDocumentHistoryProvider>
                      <BusinessLogicProvider>
                        <ComplexArtboardProvider>
                        <SidebarMenu
                          tabIndex={showVersions ? -1 : tabIndex}
                          tabClickHandler={this.tabClickHandler}
                          availableTabs={ShortMessageTabs}
                          template={templates}
                          templateDisplayName={shortMsgTextContext?.tempDetails?.name || tempName}
                          templateId={shortMsgTextContext?.tempDetails?.id}
                          groupId={shortMsgTextContext?.tempDetails?.groupId}
                          language={shortMsgTextContext?.tempDetails?.language}
                          templateName={this.setTemplateName}
                          onTemplateSave={this.onTemplateSave}
                          categoryId={shortMsgTextContext?.tempDetails?.categoryId}
                          resourceGroupId={shortMsgTextContext?.tempDetails?.resourceGroupId}
                          communicationId={shortMsgTextContext?.tempDetails?.communicationId}
                        />
                        </ComplexArtboardProvider>
                      </BusinessLogicProvider>
                    </ComplexDocumentHistoryProvider>
                    <MessageContainer
                      variablesFetched={this.context.variablesFetched}
                      updateDocumentVariables={this.updateDocumentVariables}
                      userAuthenticated={!this.context.loginVisible}
                      showVersions={showVersions}
                      tabIndex={showVersions ? -1 : tabIndex}
                      globalVariables={this.context.globalVariables}
                      setVoiceName={shortMsgTextContext?.setVoiceName}
                      voiceName={shortMsgTextContext?.voiceName}
                      setIsDraft={shortMsgTextContext?.setIsDraft}
                      documentVariables={this.context.documentVariables}
                      onHandleVersion={e => this.setState({ showVersions: e })}
                      templateId={templateId}
                      {...this.props}
                    />
                  </>
                )}
              </ShortMsgTextContext.Consumer>
            </ShortMsgTextProvider>
          </DndProvider>
        </Wrapper>
      </Container>
    );
  }
}

ShortMessageDesign.contextType = AppStoreContext;

export default ShortMessageDesign;
